import { Types } from './types'

const initialState = {
    dataVoucher: {
        filter: {},
        rows: []
    },
}
const voucherReducer = (state = initialState, action) => {
    let newState = Object.assign({}, state);
    switch (action.type) {
        case Types.SAVE_LIST_VOUCHER:
            return {
                ...newState,
                dataVoucher: action.payload
            }
        default:
            return { ...newState }
    }
}
export default voucherReducer
